var map = {
	"./U-100-only": 1,
	"./U-100-only.svg": 1,
	"./U-40-only": 2,
	"./U-40-only.svg": 2,
	"./cat": 3,
	"./cat.svg": 3,
	"./day-or-night": 4,
	"./day-or-night.svg": 4,
	"./do-not-crush": 5,
	"./do-not-crush.svg": 5,
	"./dog": 6,
	"./dog.svg": 6,
	"./empty-stomach": 7,
	"./empty-stomach.svg": 7,
	"./eyeless-doggo": 8,
	"./eyeless-doggo.jpeg": 8,
	"./give-with-food": 9,
	"./give-with-food.svg": 9,
	"./give-with-water": 10,
	"./give-with-water.svg": 10,
	"./icons/alert-eucalyptus": 11,
	"./icons/alert-eucalyptus.svg": 11,
	"./icons/right-arrow-eucalyptus": 12,
	"./icons/right-arrow-eucalyptus.svg": 12,
	"./keep-away-from-light": 13,
	"./keep-away-from-light.svg": 13,
	"./koala-logo": 14,
	"./koala-logo.svg": 14,
	"./koala-submark": 15,
	"./koala-submark.svg": 15,
	"./koala-vet-logo-prefix": 16,
	"./koala-vet-logo-prefix.svg": 16,
	"./koala-vet-logo-suffix": 17,
	"./koala-vet-logo-suffix.svg": 17,
	"./meow_party": 18,
	"./meow_party.gif": 18,
	"./prescription-logo": 19,
	"./prescription-logo.svg": 19,
	"./separate-meals": 20,
	"./separate-meals.svg": 20,
	"./speak-with-your-vet": 21,
	"./speak-with-your-vet.svg": 21,
	"./storage-temp": 22,
	"./storage-temp.svg": 22,
	"./throw-away": 23,
	"./throw-away.svg": 23
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;